/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_DescriptionInputs */

const ja_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン（PLAYBRAIN）へのお問い合わせはこちらからお願いいたします。`)
};

const en_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For inquiries to PLAYBRAIN Inc., please contact us here.`)
};

/**
* | output |
* | --- |
* | "For inquiries to PLAYBRAIN Inc., please contact us here." |
*
* @param {Contact_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_meta_description = /** @type {((inputs?: Contact_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_description(inputs)
	return en_contact_meta_description(inputs)
});